import { render, staticRenderFns } from "./AffiliateForm.vue?vue&type=template&id=99f4c37a"
import script from "./AffiliateForm.vue?vue&type=script&lang=js"
export * from "./AffiliateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports